import { useQuery } from '@tanstack/vue-query'
import { getCurrentSteps } from '../onboardingEndpoints'
import { parseCurrentSteps } from '../parsers/onboardingParser'
import { onboardingKeys } from '../onboardingQueryKeys'

export function useCurrentStepsQuery() {
  return useQuery({
    queryKey: onboardingKeys.steps(),
    queryFn: () => getCurrentSteps().then(parseCurrentSteps),
  })
}
